import authenticationController from './authentication.controller';
import authenticationService from './authentication.service';
import authenticationDataFactory from './authenticationData.factory';

export default angular
  .module('st.Authentication', ['st.Core', 'angular-cache'])
  .factory('authenticationDataFactory', authenticationDataFactory)
  .service('authenticationService', authenticationService)
  .controller('authenticationController', authenticationController)
  .constant('AUTHENTICATION', {
    API: {
      CREDENTIALS_CHECK: '/api/v1/account/authenticate/',
      ORGANIZATION_CHANGE: '/api/v1/account/organization-change/',
      PASSWORD_FORGOT: '/api/v1/account/password-forgot/',
      PASSWORD_CHANGE: '/api/v1/account/password-change/',
      TWO_FACTOR_LOST: '/api/v1/account/two-factor-lost/',
      TWO_FACTOR_SMS: '/api/v1/account/two-factor-sms/',
      TWO_FACTOR_SMS_VALIDATE: '/api/v1/account/two-factor-sms-validate/',
      TWO_FACTOR_TOGGLE: '/api/v1/account/two-factor-toggle/',
      TWO_FACTOR_VALIDATE: '/api/v1/account/two-factor-validate/'
    }
  });
